import { FaMobileAlt, FaDesktop } from "react-icons/fa";

export const MOBILE = "mobile";
export const DESKTOP = "desktop";

export const DEVICES = {
    1: {
        name: "desktop",
        label: "Desktop",
        icon: FaDesktop
    },
    2: {
        name: "mobile",
        label: "Mobile",
        icon: FaMobileAlt
    }
};



// WEBPACK FOOTER //
// ./src/modules/devices/constants.js